import styled from 'styled-components';

export const Container = styled.div`
    box-sizing: border-box;
    width: 100%;
    padding: 2rem;
    padding-top: 80px;

    img {
        width: 32px;
        height: 32px;
    }

    .close {
        position: absolute;
        right: 32px;
        top: 32px;

        @media(max-width: 600px) {
                right: 10px;
                top: 10px;
            }
        
        button {
            background-color: transparent;
            outline: none;
            cursor: pointer;
            border: none;
            align-self: center;
            box-sizing: border-box;

            .i-close {
                vertical-align: middle;
                align-self: center;
                font-size: 36px;
                top: 10px;
                bottom: 10px;
                left: 10px;
                right: 10px;
                color: #c0b7b8 !important;

                @media(max-width: 600px) {
                    font-size: 26px;
                    top: 16px;
                    bottom: 16px;
                    left: 16px;
                    right: 16px;
                }
            }
        }
    }

    h1 {
        font-family: Montserrat;
        font-size: 2rem;
        margin: 0;
        padding: 0;
        margin-top: 1.5rem;
        font-weight: 700;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        overflow: hidden;
        white-space:nowrap;
        text-overflow:ellipsis;
        width:95%;
        @media(max-width: 420px) {
                font-size: 1.5rem;
            }
    }

    h5 {
        margin: 0;
        padding: 0;
        padding-top: 1.5rem;
        font-size: 1rem;
        font-weight: normal;
        font-family: Montserrat;
        color: #a49b9b;
        line-height: 2;
        max-width: 416px;
    }

    .botoes {
        display: flex;
        padding-top: 2.5rem;
            
        .confirm {
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #c32027;
            outline: none;
            border: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;

            :hover {
                background-color: #9c1a1f
            }

            :active {
                background-color: #d7232c
            }
            @media(max-width: 360px) {
                width: 100%;
            }
        }

        .cancel {
            /* margin-bottom: -56px;  */
            margin-left: 1rem;
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #fff;
            border: 1px solid #c32027;
            outline: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #c32027;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;
            :hover {
                background-color: #faf8f8
            }

            :active {
                background-color: #dedede
            }
            @media(max-width: 360px) {
                width: 100%;
            }
        }
    }
`